var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#E8E8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4955 20.445C10.189 20.7237 10.1664 21.198 10.445 21.5045C10.7237 21.811 11.198 21.8336 11.5045 21.555L11 21L10.4955 20.445ZM22.7492 11.0357C22.7689 10.6219 22.4494 10.2706 22.0357 10.2508L15.2933 9.92978C14.8796 9.91008 14.5282 10.2295 14.5085 10.6433C14.4888 11.057 14.8082 11.4084 15.222 11.4281L21.2152 11.7135L20.9298 17.7067C20.9101 18.1204 21.2295 18.4718 21.6433 18.4915C22.057 18.5112 22.4084 18.1918 22.4281 17.778L22.7492 11.0357ZM11 21L11.5045 21.555L22.5045 11.555L22 11L21.4955 10.445L10.4955 20.445L11 21Z",
    fill: "#6466E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.0b90cc02.svg";
export { ForwardRef as ReactComponent };